// Helper function to convert PascalCase/camelCase to kebab-case
const toKebabCase = (str) => {
  return str
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1-$2")
    .toLowerCase();
};

export const getDetailLink = ({
  sourceModel,
  sourceRef,
  type = null,
  intendedUser,
  isCustomer,
  isDriver,
  isVendor,
  isContractor,
  isVendorStaff,
  contextData = {},
}) => {
  let link = "";
  let source = !type ? sourceModel : sourceModel + "/" + type;

  let userAccess = isCustomer
    ? "customer"
    : isDriver
    ? "driver"
    : isVendor
    ? "vendor"
    : isVendorStaff
    ? "staff"
    : isContractor
    ? "contractor"
    : "crm";

  switch (source) {
    case "Application":
      link = `/app/${userAccess}/application/${sourceRef}/detail`;
      break;

    case "Customer":
      link = `/app/${userAccess}/customer/${sourceRef}/detail`;
      break;
    case "Contractor":
      link = `/app/${userAccess}/contractor/${sourceRef}/detail`;
      break;
    case "Vendor":
      link = `/app/${userAccess}/Vendor/${sourceRef}/detail`;
      break;
    case "VendorStaff":
      link = `/app/${userAccess}/staff/${sourceRef}/detail`;
      break;
    case "Driver":
      link = `/app/${userAccess}/driver/${sourceRef}/detail`;
      break;

    case "Client/TRACKER":
      link = `/app/${userAccess}/client/tracker?responsible=${intendedUser}`;
      break;

    case "DynamicForm/MODEL_SPECIFIC":
      link = `/app/${userAccess}/form`;
      break;

    case "Issue":
      link = `/app/${userAccess}/issue/${sourceRef}/detail`;
      break;

    case "Lead":
      link = `/app/${userAccess}/lead/${sourceRef}/detail?tab=inquiry`;
      break;

    case "Lead/TRACKER":
      link = `/app/${userAccess}/lead/tracker?responsible=${intendedUser}`;
      break;

    case "Submission/MODEL_SPECIFIC":
      link = `/app/${userAccess}/form`;
      break;

    case "Transaction":
      link = `/app/${userAccess}/transaction/${sourceRef}/detail`;
      break;

    case "Transaction/TRACKER":
      link = `/app/${userAccess}/transaction/tracker?responsible=${intendedUser}`;
      break;

    case "Task":
      link = `/app/${userAccess}/task/${sourceRef}/detail`;
      break;

    case "DriverTransferRequest/MODEL_SPECIFIC":
      link = `/app/${userAccess}/dashboard`;
      break;

    case "Ticket":
      link = `/app/${userAccess}/ticket/${sourceRef}/detail`;
      break;

    // Add specific case for CODTransfer
    case "CODTransfer/MODEL_SPECIFIC":
      link = `/app/${userAccess}/cod-transfer/${sourceRef}/detail`;
      break;

    // For Vendor Lead notification navigation
    case "VendorLeadTask/MODEL_SPECIFIC":
      link = `/app/${userAccess}/vendor-lead/${contextData.leadId}/detail?tab=tasks`;
      break;

    case "BranchTally/MODEL_SPECIFIC":
      link =
        contextData?.status === "InProgress"
          ? `/app/${userAccess}/branch-tally/scan/${sourceRef}`
          : `/app/${userAccess}/branch-tally/${sourceRef}/detail`;
      break;

    default:
      // Use kebab-case conversion for any MODEL_SPECIFIC notifications
      if (source.endsWith("/MODEL_SPECIFIC")) {
        const modelName = sourceModel.replace("/MODEL_SPECIFIC", "");
        link = `/app/${userAccess}/${toKebabCase(
          modelName,
        )}/${sourceRef}/detail`;
      }
      break;
  }

  return link;
};
